import AccountingInfoOption from './AccountingInfoOption';

export default class ShipmentMethod extends AccountingInfoOption {
    public static entity = 'shipmentMethods';
    public static apiType = 'shipment-methods';
    public static storageKey = 'shipment_methods_list';
}